export var prefix = 'dentsu';
export var version = {
  core: '0.40.13',
  tokens: '0.0.15',
  elements: '1.17.6',
  charts: '1.3.7',
  icons: 'soon',
  spreadsheet: '0.1.5',
  planner: '1.0.122'
};